import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]

interface Props {
  /** Whether the button is in loading state */
  loading?: boolean
  /** Whether the button is filled (primary) or not (secondary) */
  filled?: boolean
  /** Whether the button is disabled */
  disabled?: boolean
  /** Button type attribute */
  type?: HTMLButtonElement['type']
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseButton'
},
  __name: 'BaseButton',
  props: {
    loading: { type: Boolean },
    filled: { type: Boolean },
    disabled: { type: Boolean },
    type: { default: 'submit' }
  },
  setup(__props: any) {

/**
 * Deprecated button component
 * @deprecated Use PrimaryButton, SecondaryButton or TextButton instead
 */





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", {
      secondary: !__props.filled,
      'cursor-not-allowed': __props.loading,
      loading: __props.loading
    }]),
    type: __props.type,
    disabled: __props.loading || __props.disabled
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _cache[0] || (_cache[0] = _createTextVNode("OK", -1))
    ])
  ], 10, _hoisted_1))
}
}

})